import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const IP_SECURITY_EVENT_NAMES = {
  ADD_IP_ADDRESS: 'admin_adds_ip_address_successfully',
  PAUSE_IP_ACCESS: 'admin_pauses_ip_access_restriction',
};

export const trackAddIPAddressSuccess = () => {
  gspx.trackEvent({
    name: IP_SECURITY_EVENT_NAMES.ADD_IP_ADDRESS,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: 'Admin adds IP Address successfully',
      Category: 'Admin',
      'Launched date': new Date(),
    },
  });
};

export const trackPauseIPAccessSuccess = () => {
  gspx.trackEvent({
    name: IP_SECURITY_EVENT_NAMES.PAUSE_IP_ACCESS,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: 'Admin pauses IP access restriction',
      Category: 'Admin',
      'Launched date': new Date(),
    },
  });
};
